import { Component, Input } from '@angular/core';
import { IOdbBillCategoryDetail } from '@dch/billing-business-logic';

@Component({
  selector: 'my-bill-odb-category-details',
  templateUrl: './odb-category-details.component.html',
  standalone: false,
})
export class OdbCategoryDetailsComponent {
  @Input() categoryDetails: Array<IOdbBillCategoryDetail>;
  @Input() billingAccountNumber: string;
  @Input() productSplitIdentifier?: string;
  @Input() documentReference: string;
  @Input() category: 'usage' | 'oneTimeCharge';
}
